import { useCallback, useRef, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";

import { useTeams } from "../../../../reactQuery/teams";
import useMutate from "../../../../hooks/useMutate";
import { updateImage } from "../../../../services/apiUploadImage";
import {
  getInitialUserImagePreview,
  isValidImageFile,
} from "../utils/userProfileFormUtils";

export function useUserProfileForm({ profileData, userId }) {
  const { teams } = useTeams();
  const teamsArray = teams?.data?.data?.responseData;
  const fileInputRef = useRef(null);
  const queryClient = useQueryClient();

  const [preview, setPreview] = useState(getInitialUserImagePreview(profileData));
  const { mutate: mutateProfile } = useMutate(updateImage, ["users"], () => {}, () => {
    queryClient.invalidateQueries({
      queryKey: ["userProfile", userId],
    });
  });

  const handleFileChange = useCallback(
    (event) => {
      const file = event.target.files[0];
      if (!file) return;

      if (!isValidImageFile(file)) {
        toast.error("Choose an Image to upload.");
        event.target.value = "";
        return;
      }

      const newPreview = URL.createObjectURL(file);
      setPreview(newPreview);
      mutateProfile({ user_id: userId, user_image: file });
    },
    [mutateProfile, userId]
  );

  return {
    fileInputRef,
    handleFileChange,
    preview,
    teamsArray,
  };
}
